import React, { memo } from "react";
import { getRangeColor } from "../../../constants/rollet";

const ColorCard = ({ color, onBetting, isWin, oldResult }) => {
    if (!color) return null;

    const isWinner = isWin && oldResult?.colorCode === color.code;

    const handleClick = () => {
        if (typeof onBetting === "function") {
            onBetting(color);
        }
    };

    const className = `card-number color-group-${color.code} ${
        isWinner ? "win-animation" : ""
    }`;

    return (
        <div onClick={handleClick} className={className}>
            <div className="numbers text-nowrap">
                {getRangeColor?.[color.code]}
            </div>

            <div className="content">
                {color.value}
            </div>
        </div>
    );
};

export default memo(ColorCard);